import React from "react"
import { Droppable } from "react-beautiful-dnd"
import RoadmapperCalenderEvent from "../RoadmapperCalenderEvent/RoadmapperCalenderEvent"

export default function RoadmapperCalenderContainer({
  eventIds,
  timeEvents,
  constraintEnd,
  constraintStart,
  isEditing,
  updateParentState,
  renderMoment,
  isBeingDragged,
  isDragDisabled,
  eventIdBeingEdited,
  updateEditEvent,
  deleteTimeEvent,
  skeletonLoader
}) {
  return (
    <div>
      <Droppable droppableId="TIME_EVENTS">
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            style={styles.container}
          >
            {eventIds && eventIds.length > 0 && timeEvents && timeEvents.length > 0 ? (
              eventIds
                .map((id) => {
                  const event = timeEvents.find((event) => event.id === id)
                  return event ? { id, event } : null
                })
                .filter((item) => item !== null)
                .map((item, index) => {
                  const { id, event } = item
                  return (
                    <RoadmapperCalenderEvent
                      skeletonLoader={skeletonLoader}
                      {...provided.droppableProps}
                      constraintStart={constraintStart}
                      constraintEnd={constraintEnd}
                      isEditing={isEditing}
                      updateParentState={updateParentState}
                      timeEvent={event}
                      key={event.id || `event-${id}-${index}`}
                      index={index}
                      isDragDisabled={isDragDisabled}
                      renderMoment={renderMoment}
                      isBeingDragged={isBeingDragged}
                      updateEditEvent={updateEditEvent}
                      deleteTimeEvent={deleteTimeEvent}
                      editingComponent={eventIdBeingEdited === event.id}
                    />
                  )
                })
            ) : (
              <></>
            )}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  )
}

const styles = {
  container: {
    maxWidth: "699px"
  }
}
